import {useEffect, useState} from "react"

import "./Test.css"
import tableSearch from "../../assets/tableSearch.svg"
import tableRefresh from "../../assets/tableRefresh.svg"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import PersonalTab from "../../component/Test/PersonalTab"
import SendModal from "../../component/Modal/SendModal"
import {getCode, getDateStr, retrieveData, sendRequest} from "../../common";
import itemCheck from "../../component/Shop/ItemCheck";

function PersonalComplete() {

	const [SendOpen, setSendOpen] = useState(false)
	const showSend = () => {
		setSendOpen(true)
	}

	const [user, setUser] = useState()
	const [applyTests, setApplyTests] = useState([])
	const [applyTest, setApplyTest] = useState()

	const [tests, setTests] = useState([])
	const [testId, setTestId] = useState('')
	const [isDone, setIsDone] = useState('')
	const [name, setName] = useState('')

	const [selected, setSelected] = useState([])

	const getTests = () => {
		sendRequest('test/test/', 'GET', null, data => {
			setTests(data)
		})
	}

	const getSentApplyTests = (user, name='') => {
		sendRequest(`test/apply-test/?sender=${user?.id}&isSent=True&size=1000&test=${testId}&isDone=${isDone}&name=${name}&group=개인`, 'GET', null, data => {
			setApplyTests(data)
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			getSentApplyTests(user)
		})
		getTests()
	}, [])

	useEffect(() => {
		getSentApplyTests(user, name)
	}, [testId, isDone])

	const deleteAll = (applyTests, index) => {
		if (applyTests?.length -1 < index) {
			getSentApplyTests(user)
			alert('모두 삭제 되었습니다. 미실시 항목은 인증코드가 반환 되었습니다.')
			return
		}

		sendRequest(`test/apply-test/${applyTests[index]?.id}/`, 'DELETE', null, data => {
			deleteAll(applyTests, index + 1)
		})
	}

	const returnCode = (applyTests, index) => {
		if (applyTests?.filter(item => !!item.isDone)?.length) {
			alert('이미 실시한 상태가 있어, 인증코드 반환이 불가 합니다.')
			return
		}

		if (applyTests?.length - 1 < index) {
			getSentApplyTests(user)
			alert('인증코드가 모두 반환 되었습니다.')
			return
		}

		sendRequest(`test/apply-test/${applyTests[index]?.id}/`, 'DELETE', null, data => {
			returnCode(applyTests, index + 1)
		})
	}

	const onSelected = (checked, obj) => {
		if (checked) {
			selected.push(obj)
			setSelected(Object.assign([], selected))
		} else {
			const index = selected.findIndex(item => item.id === obj.id)
			if (index !== -1) {
				selected.splice(index)
				setSelected(Object.assign([], selected))
			}
		}
	}

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"개인검사 인증코드"} />
					<div className="testWrap">
						<PersonalTab isLast={true} />
						<section className="personalComplete">
							<form name="personalComplete">
									<div className="tableTab">
										<div className="tableBtn">
											<button type="button" onClick={e => {
												e.preventDefault()
												deleteAll(selected, 0)
											}}>선택 삭제</button>
											<button type="button" onClick={e => {
												e.preventDefault()
												returnCode(selected, 0)
											}}>인증코드 반환</button>
											<button type="button" className="refreshBtn" onClick={e => {
												e.preventDefault()
												getSentApplyTests(user, '')
											}}>새로고침</button>
											<span>총 {applyTests?.length}건</span>
										</div>
										<div className="tableSearch">
											<span className="selectWrap">
												<select name="" onChange={e => setTestId(e.target.value)}>
													<option defaultValue="">검사 종류</option>
													{tests?.map(item => {
														return (
															<option value={item?.id}>{item?.name}</option>
														)
													})}
												</select>
											</span>
											<span className="selectWrap">
												<select name="" onChange={e => setIsDone(e.target.value)}>
													<option defaultValue="">상태</option>
													<option value={false}>미실시</option>
													<option value={true}>완료</option>
												</select>
											</span>
											<span className="selectWrap">
												<select name="">
													<option defaultValue="">이름</option>
												</select>
											</span>
											<span className="inputWrap">
												<input type="text" name="" placeholder="검색어 입력" value={name} onChange={e => setName(e.target.value)}/>
											</span>
											<button type="button" className="searchBtn" onClick={e => {
												e.preventDefault()
												getSentApplyTests(user, name)
											}}>
												<img src={tableSearch} alt="검색 버튼" />
											</button>
											<button type="button" onClick={e => {
												e.preventDefault()
												setName('')
												// setTestId('')
												// setIsDone('')
												getSentApplyTests(user, '')
											}}>
												<img src={tableRefresh} alt="초기화 버튼" />
											</button>
											<span className="selectWrap">
												<select name="">
													<option defaultValue="">20개씩 보기</option>
												</select>
											</span>
										</div>
									</div>
								<div className="testTableWrap">
									<table className="testTable">
										<colgroup>
											<col width="3%"/>
											<col width="12%"/>
											<col width="7%"/>
											<col width="15%"/>
											<col width="15%"/>
											<col width="10%"/>
											<col width="5%"/>
											<col width="10%"/>
											<col width="10%"/>
											<col width="5%"/>
											<col width="8%"/>
										</colgroup>
										<thead>
											<tr>
												<th>
													<div className="formCheckbox">
														<input type="checkbox" id="tableSelect"
																	 onChange={e => {
																		 if (e.target.checked) {
																			 setSelected(applyTests)
																		 } else {
																			 setSelected([])
																		 }
																	 }}
														/>
														<label htmlFor="tableSelect"></label>
													</div>
												</th>
												<th>검사종류</th>
												<th>이름</th>
												<th>인증코드</th>
												<th>이메일</th>
												<th>휴대폰 번호</th>
												<th>상태</th>
												<th>발송일</th>
												<th>최종접속일</th>
												<th>메일/문자</th>
												<th>발송현황</th>
											</tr>
										</thead>
										<tbody>
											{applyTests?.map((item, index) => {
												return (
													<tr>
														<td>
															<div className="formCheckbox">
																<input type="checkbox" id={`tableSelect${index}`} checked={selected?.findIndex(s => s?.id === item?.id) !== -1} onChange={e => onSelected(e.target.checked, item)}/>
																<label htmlFor={`tableSelect${index}`}></label>
															</div>
														</td>
														<td>{item?.test?.name}</td>
														<td>{item?.name}</td>
														<td>{getCode(item?.code)}</td>
														<td>{item?.email}</td>
														<td>{item?.phone}</td>
														<td className="complete">{item?.isDone ? '완료' : '미실시'}</td>
														<td>{getDateStr(new Date(item?.sendDateTime))}</td>
														<td>{getDateStr(new Date(item?.user?.last_login))}</td>
														<td>메일/문자</td>
														<td>
															<button type="button" className="viewBtn" onClick={() => {
																setApplyTest(item)
																showSend()
															}}>보기</button>
														</td>
													</tr>
												)
											})}

											{/*<tr className="checkedRow">*/}
											{/*	<td>*/}
											{/*		<div className="formCheckbox">*/}
											{/*			<input type="checkbox" id="tableSelect3" name="tableSelect3" defaultChecked />*/}
											{/*			<label htmlFor="tableSelect2"></label>*/}
											{/*		</div>*/}
											{/*	</td>*/}
											{/*	<td>PTS 심리유형탐색</td>*/}
											{/*	<td>홍길동</td>*/}
											{/*	<td>XXXX-XXXX-XXXX-XXXX</td>*/}
											{/*	<td>example@example.com</td>*/}
											{/*	<td>010-1234-5678</td>*/}
											{/*	<td className="notComplete">미실시</td>*/}
											{/*	<td>2023-07-07</td>*/}
											{/*	<td>2023-07-08</td>*/}
											{/*	<td className="complete">완료</td>*/}
											{/*	<td>*/}
											{/*		<button type="button" className="viewBtn" onClick={showSend}>보기</button>*/}
											{/*	</td>*/}
											{/*</tr>*/}
										</tbody>
									</table>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>

			{SendOpen && (
				<SendModal
					setSendOpen={setSendOpen}
					title1={"회 이메일 발송완료"}
					text1={`(${applyTest?.email})`}
					title2={"휴대폰 발송완료"}
					text2={`(${applyTest?.phone})`}
					info={"최대 3회까지 발송 가능합니다."}
					applyTest={applyTest}
					reload={() => getSentApplyTests(user, name)}
				/>
			)}

			<RightFooter />
		</>
	)
}

export default PersonalComplete
